import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { RequestRelatedTree, RequestRelatedTreeNode } from '../../models/request/request-related-tree';
import { RequestType } from '../../enums';

@Component({
	selector: 'related-requests-tree',
	templateUrl: './related-requests-tree.component.html',
	styleUrls: ['./related-requests-tree.component.scss']
})
export class RelatedRequestsTreeComponent implements OnChanges {

	@Input()
	tree: RequestRelatedTree;

	@Input()
	currentRequestId: number;

	@Input()
	requestTypeId: number;

	@Input()
	serviceRequestTypeId: number = RequestType.service;

	@Input()
	montageRequestTypeId: number = RequestType.install;

	/** Доп. отступ сверху для выравнивания с первым виджетом слева. */
	@Input()
	topMarginPx: number = 0;

	@Output()
	visibilityChange = new EventEmitter<boolean>();

	showCreateButtons = false;

	ngOnChanges(changes: SimpleChanges): void {
		this.showCreateButtons = this.requestTypeId === RequestType.consultation;
		this.visibilityChange.emit(this.isVisible);
	}

	/** На консультации блок виден всегда (кнопки создания); на остальных — только при наличии дерева. */
	get isVisible(): boolean {
		return this.showCreateButtons || (!!this.tree && !!this.tree.root);
	}

	get hasTree(): boolean {
		return !!this.tree && !!this.tree.root;
	}

	isCurrent(node: RequestRelatedTreeNode): boolean {
		return node && node.requestId === this.currentRequestId;
	}

	onNodeClick(node: RequestRelatedTreeNode): void {
		if (!node || this.isCurrent(node)) {
			return;
		}

		window.open(`/requests/${node.requestId}`, '_blank');
	}

	createServiceRequest(): void {
		if (!this.currentRequestId) {
			return;
		}

		const url = `/requests/new?parentRequestId=${this.currentRequestId}&requestTypeId=${this.serviceRequestTypeId}`;
		window.open(url, '_blank');
	}

	createMontageRequest(): void {
		if (!this.currentRequestId) {
			return;
		}

		const url = `/requests/new?parentRequestId=${this.currentRequestId}&requestTypeId=${this.montageRequestTypeId}`;
		window.open(url, '_blank');
	}

	/** Рамка и фон бейджа из цвета статуса (Color / GroupTreeColor в БД). */
	getStatusPillStyle(node: RequestRelatedTreeNode): { [key: string]: string } {
		const color = this.normalizeHex(node && node.statusColor);
		const rgb = this.hexToRgb(color);

		return {
			'background-color': rgb ? `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.18)` : '#f0f0f0',
			'border-color': color,
			'color': '#333'
		};
	}

	private normalizeHex(value: string): string {
		const fallback = '#6c757d';
		if (!value) {
			return fallback;
		}

		let hex = value.trim();
		if (!hex) {
			return fallback;
		}

		if (hex.charAt(0) !== '#') {
			hex = '#' + hex;
		}

		if (/^#[0-9a-fA-F]{3}$/.test(hex)) {
			return '#' + hex.charAt(1) + hex.charAt(1) + hex.charAt(2) + hex.charAt(2) + hex.charAt(3) + hex.charAt(3);
		}

		if (/^#[0-9a-fA-F]{6}$/.test(hex)) {
			return hex;
		}

		return fallback;
	}

	private hexToRgb(hex: string): { r: number; g: number; b: number } {
		if (!hex || hex.length !== 7) {
			return null;
		}

		const r = parseInt(hex.substr(1, 2), 16);
		const g = parseInt(hex.substr(3, 2), 16);
		const b = parseInt(hex.substr(5, 2), 16);

		if (isNaN(r) || isNaN(g) || isNaN(b)) {
			return null;
		}

		return { r, g, b };
	}
}
